import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Grid, Linha } from '../../styles/base';
import imagemNaoDisponivel from '../../assets/images/imagemindisponivel.png';
import { ListaNoticiaBox, BoxImagem, InfoContainer } from './ListaNoticiaEstilo';

const ListaNoticia = ({
  fotoCapaThumb, titulo, dataHora, descricao,
}) => (
  <ListaNoticiaBox
    className="teste"
  >
    {(((fotoCapaThumb !== '') && (fotoCapaThumb !== null))
      ? (
        <BoxImagem style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #0000000a',
        }}
        >
          <img
            style={{
              objectFit: 'cover', objectPosition: 'center', maxWidth: '100%', width: '100%', height: 215,
            }}
            src={fotoCapaThumb}
            alt={titulo}
          />
        </BoxImagem>
      )
      : (
        <BoxImagem>
          <img
            style={{
              objectFit: 'cover', objectPosition: 'center', maxWidth: '100%', height: 215,
            }}
            src={imagemNaoDisponivel}
            alt={titulo}
          />
        </BoxImagem>
      ))}
    <InfoContainer style={{ padding: '10px' }}>
      <span style={{
        fontSize: 11, marginBottom: 10, padding: 8, color: 'white', display: 'block', background: '#1C75BC', position: 'absolute', top: '-18px', fontWeight: 'bolder',
      }}
      >
        {dataHora}
      </span>
      <p style={{
        marginTop: 5, fontSize: 15, fontWeight: 'bold', width: '100%', maxWidth: '100%',
      }}
      >
        {titulo}
      </p>
      <p style={{
        marginTop: 5, fontSize: 12, width: '100%',
      }}
      >
        {descricao}

      </p>
    </InfoContainer>
  </ListaNoticiaBox>
);

ListaNoticia.propTypes = {
  fotoCapaThumb: PropTypes.string,
  titulo: PropTypes.string,
  dataHora: PropTypes.string,
  descricao: PropTypes.string,
};

ListaNoticia.defaultProps = {
  fotoCapaThumb: '',
  titulo: '',
  dataHora: '',
  descricao: '',
};

export default ListaNoticia;
